/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PushDeliveryMetaReason } from 'cio/models/delivery';

interface PushActionResultsGroupArgs {
  type: 'drafted' | 'sent' | 'undeliverable' | 'bounced' | 'suppressed' | 'failed';
  isExpandedOnInit: boolean;
  timestamp: number;
  deliveries: PushDeliveryMetaReason[];
}

export default class PushActionResultsGroup extends Component<PushActionResultsGroupArgs> {
  @tracked isExpanded!: boolean;

  constructor(owner: unknown, args: PushActionResultsGroupArgs) {
    super(owner, args);
    this.isExpanded = args.isExpandedOnInit;
  }

  get typeClassName() {
    let { type } = this.args;

    if (type === 'sent') {
      return { label: 'text-success', message: 'text-success' };
    } else if (type === 'bounced' || type === 'suppressed') {
      return { label: 'text-default', message: 'text-warning' };
    } else if (type === 'drafted') {
      return { label: 'text-warning', message: 'text-warning' };
    } else if (type === 'failed') {
      return { label: 'text-error', message: 'text-error' };
    }

    return {
      label: '',
      message: '',
    };
  }
}
